import { EIIState } from '@shared';

export const IInvoiceRawProperties = [
  'Ref',
  'Number',
  'DateTime',
  'DeletionMark',
  'InternationalExpressWaybill',
  'CreationDate',
  'PhoneSender',
  'EmailSender',
  'CounterpartySender',
  'CounterpartySenderTranslit',
  'ContactPersonSender',
  'ContactPersonSenderTranslit',
  'CitySender',
  'CityOfResidenceSender',
  'SenderFlat',
  'ZipCodeOfResidenceSender',
  'WarehouseSender',
  'CounterpartyRecipientRef',
  'WarehouseRecipient',
  'DeliveryType',
  'PayerType',
  'PaymentMethod',
  'TypeOfShipment',
  'PlacesAmount',
  'CargoDescription',
  'CargoDescriptionEnglish',
  'ExportReason',
  'AdditionalInformationExportReason',
  'Incoterm',
  'Currency',
  'DocumentCost',
  'Cost',
  'ClientInvoice',
  'CounterpartySenderDescription',
  'CounterpartySenderLastName',
  'CounterpartySenderMiddleName',
  'CounterpartySenderFirstName',
  'CitySenderDescription',
  'WarehouseSenderDescription',
  'CounterpartySenderFromWarehouse',
  'CityOfResidenceSenderDescription',
  'CityOfResidenceSenderDescriptionEn',
  'CounterpartySenderStreetRef',
  'CounterpartySenderStreet',
  'CounterpartySenderStreetEn',
  'CounterpartySenderHouse',
  'PhoneRecipient',
  'EmailRecipient',
  'CounterpartyTypeRecipient',
  'CounterpartyRecipient',
  'ContactPersonRecipient',
  'CounterpartyRecipientLastName',
  'CounterpartyRecipientFirstName',
  'ZipCodeRecipient',
  'CountryRecipient',
  'CountryRecipientDescription',
  'CountryRecipientDescriptionEn',
  'CityRecipient',
  'AddressRecipient',
  'RegionRecipientCode',
  'CounterpartyRecipientStreet',
  'CounterpartyRecipientHouse',
  'CounterpartyRecipientApart',
  'AdditionalInfoRecipient',
  'WarehouseRecipientDescription',
  'WarehouseRecipientOwner',
  'WarehouseRecipientCategory',
  'TypeOfShipmentDescription',
  'ExportReasonDescription',
  'DeliveryTypeDescription',
  'CurrencyCode',
  'IncotermDescription',
  'Places',
  'State',
  'CanPrint',
  'ThirdPersonRef',
  'ThirdPerson',
  'SenderAddressRef',
  'SenderAddressRegistrationRef',
  'DocumentCostCurrencyCode',
  'SubStateDocument',
  'ScanSheetRef',
  'ScanSheetNumber',
  'ScanSheetPrinted',
];

export interface IInternationalInvoiceRaw {
  Ref: string;
  Number: string;
  DateTime: string;
  DeletionMark: string;
  InternationalExpressWaybill: string;
  CreationDate: string;
  PhoneSender: string;
  EmailSender: string;
  CounterpartySender: string;
  CounterpartySenderTranslit: string;
  ContactPersonSender: string;
  ContactPersonSenderTranslit: string;
  CitySender: string;
  CityOfResidenceSender: string;
  SenderFlat: string;
  ZipCodeOfResidenceSender: string;
  WarehouseSender: string;
  CounterpartyRecipientRef: string;
  WarehouseRecipient: string | null;
  DeliveryType: string;
  PayerType: string;
  PaymentMethod: string;
  TypeOfShipment: string;
  PlacesAmount: string;
  CargoDescription: string;
  CargoDescriptionEnglish: string;
  ExportReason: string;
  AdditionalInformationExportReason: string;
  Incoterm: string;
  Currency: string;
  DocumentCost: number;
  Cost: number;
  ClientInvoice: string;
  CounterpartySenderDescription: string;
  CounterpartySenderLastName: string;
  CounterpartySenderMiddleName: string;
  CounterpartySenderFirstName: string;
  CitySenderDescription: string;
  WarehouseSenderDescription: string;
  CounterpartySenderFromWarehouse: boolean;
  CityOfResidenceSenderDescription: string;
  CityOfResidenceSenderDescriptionEn: string;
  CounterpartySenderStreetRef: string;
  CounterpartySenderStreet: string;
  CounterpartySenderStreetEn: string;
  CounterpartySenderHouse: string;
  PhoneRecipient: string;
  EmailRecipient: string;
  CounterpartyTypeRecipient: string;
  CounterpartyRecipient: string;
  ContactPersonRecipient: string;
  CounterpartyRecipientLastName: string;
  CounterpartyRecipientFirstName: string;
  ZipCodeRecipient: string;
  CountryRecipient: string;
  CountryRecipientDescription: string;
  CountryRecipientDescriptionEn: string;
  CityRecipient: string;
  AddressRecipient: string;
  RegionRecipientCode: string;
  CounterpartyRecipientStreet: string;
  CounterpartyRecipientHouse: string;
  CounterpartyRecipientApart: string;
  AdditionalInfoRecipient: string;
  WarehouseRecipientDescription: string;
  WarehouseRecipientOwner: string;
  WarehouseRecipientCategory: string;
  TypeOfShipmentDescription: string;
  ExportReasonDescription: string;
  DeliveryTypeDescription: string;
  CurrencyCode: string;
  IncotermDescription: string;
  Places: IInternationalInvoicePlace[];
  State: string;
  CanPrint: boolean;
  ThirdPersonRef: string;
  ThirdPerson: string;
  SenderAddressRef: string;
  SenderAddressRegistrationRef: string;
  DocumentCostCurrencyCode: string;
  SubStateDocument: string;
  ScanSheetRef: string;
  ScanSheetNumber: string;
  ScanSheetPrinted: string;
}

export class InternationalInvoice {
  Ref: string;
  Number: string;
  DateTime: string;
  DeletionMark: string;
  InternationalExpressWaybill: string;
  CreationDate: string;
  PhoneSender: string;
  EmailSender: string;
  CounterpartySender: string;
  CounterpartySenderTranslit: string;
  ContactPersonSender: string;
  ContactPersonSenderTranslit: string;
  CitySender: string;
  CityOfResidenceSender: string;
  SenderFlat: string;
  ZipCodeOfResidenceSender: string;
  WarehouseSender: string;
  CounterpartyRecipientRef: string;
  WarehouseRecipient: string | null;
  DeliveryType: string;
  TypeOfShipment: string;
  PlacesAmount: string;
  CargoDescription: string;
  CargoDescriptionEnglish: string;
  ExportReason: string;
  AdditionalInformationExportReason: string;
  Incoterm: string;
  Currency: string;
  DocumentCost: number;
  Cost: number;
  ClientInvoice: string;
  CounterpartySenderDescription: string;
  CounterpartySenderLastName: string;
  CounterpartySenderMiddleName: string;
  CounterpartySenderFirstName: string;
  CitySenderDescription: string;
  WarehouseSenderDescription: string;
  CounterpartySenderFromWarehouse: boolean;
  CityOfResidenceSenderDescription: string;
  CityOfResidenceSenderDescriptionEn: string;
  CounterpartySenderStreetRef: string;
  CounterpartySenderStreet: string;
  CounterpartySenderStreetEn: string;
  CounterpartySenderHouse: string;
  PhoneRecipient: string;
  EmailRecipient: string;
  CounterpartyTypeRecipient: string;
  CounterpartyRecipient: string;
  ContactPersonRecipient: string;
  CounterpartyRecipientLastName: string;
  CounterpartyRecipientFirstName: string;
  ZipCodeRecipient: string;
  CountryRecipient: string;
  CountryRecipientDescription: string;
  CountryRecipientDescriptionEn: string;
  CityRecipient: string;
  AddressRecipient: string;
  RegionRecipientCode: string;
  CounterpartyRecipientStreet: string;
  CounterpartyRecipientHouse: string;
  CounterpartyRecipientApart: string;
  AdditionalInfoRecipient: string;
  WarehouseRecipientDescription: string;
  WarehouseRecipientOwner: string;
  WarehouseRecipientCategory: string;
  TypeOfShipmentDescription: string;
  ExportReasonDescription: string;
  DeliveryTypeDescription: string;
  CurrencyCode: string;
  IncotermDescription: string;
  Places: IInternationalInvoicePlace[];
  State: EIIState;
  CanPrint: boolean;
  ThirdPersonRef: string;
  ThirdPerson: string;
  SenderAddressRef: string;
  SenderAddressRegistrationRef: string;
  DocumentCostCurrencyCode: string;
  SubStateDocument: string;
  ScanSheetRef: string;
  ScanSheetNumber: string;
  ScanSheetPrinted: string;

  // Computed properties
  Weight?: number;
  VolumetricWeight?: number;
  PayerType: string;
  PaymentMethod: string;
}

export interface IInternationalInvoicePlace {
  ActualWeight: number;
  Width: number;
  Length: number;
  Height: number;
  VolumetricWeight: number;
}